export const ROOT = "/";
export const LOGIN = "/login";
export const COUNTRY = "/country";
export const DASHBOARD = "/dashboard";
